import { Fetcher } from '@this/src/util';
import React, { useEffect, useMemo, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { reportError } from '@this/lib/bugsnag';
import { Link } from '@this/shared/ui/navigations/link';
import { Loading } from '../../shared/ui/feedbacks/loading/loading';
import { createColors } from '../../shared/ui/theme/tokens/primitive-tokens/colors';

import type User from '../../../domain/user/user';

const brandColors = createColors(1).brand;

interface Props {
  user: User | null | undefined;
}

const Confirmation = ({ user }: Props) => {
  const [loading, setLoading] = useState(true);
  const [confirmed, setConfirmed] = useState(false);
  const styles = useMemo(() => getStyles(), []);

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    const token = utils.getParam('confirmation_token');
    try {
      await Fetcher.get('/aiexpense/users/confirmation.json', {
        confirmation_token: token
      });
      setConfirmed(true);
      mixpanel.track('[Biztra] sign up confirmed');
    } catch {
      setConfirmed(false);
      mixpanel.track('[Biztra] sign up confirmation failed');
    } finally {
      setLoading(false);
    }
  };

  try {
    if (user) {
      return <Redirect to="/aiexpense/report_items" />;
    }

    return (
      <div className="expenses-users-signup" style={styles.container}>
        <div style={styles.content}>
          {loading ? (
            <Loading />
          ) : confirmed ? (
            <>
              <div style={styles.title}>メールアドレスの確認が完了しました！</div>
              <p style={styles.message}>下記リンクからログインしてご利用いただけます</p>
              <a href="/aiexpense/users/sign_in" style={styles.button}>
                ログインして始める
              </a>
            </>
          ) : (
            <>
              <div style={styles.title}>リンクの有効期限が切れています</div>
              <p style={styles.message}>下記のリンクから再度仮登録を行ってください。</p>
              <Link href="/aiexpense/users/sign_up">仮登録ページ</Link>
            </>
          )}
        </div>
      </div>
    );
  } catch (e) {
    reportError(e);
    return null;
  }
};

const getStyles = () => ({
  container: {
    maxWidth: '600px',
    width: '100%',
    margin: '80px auto'
  },
  content: {
    padding: '40px',
    background: 'white',
    borderRadius: '8px',
    textAlign: 'center' as const,
    fontSize: '16px'
  },
  title: {
    fontSize: '22px',
    fontWeight: 'bold' as const,
    marginBottom: '16px'
  },
  message: {
    color: '#555',
    fontWeight: 'normal' as const,
    marginBottom: '32px',
    lineHeight: '1.6'
  },
  button: {
    display: 'inline-block',
    padding: '12px 32px',
    background: brandColors[500],
    color: 'white',
    borderRadius: '4px',
    fontWeight: 'bold' as const,
    textDecoration: 'none',
    fontSize: '15px',
    cursor: 'pointer'
  }
});

export default Confirmation;
